import { Component, ElementRef, NgZone, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedService } from '../Services/sharedService';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ProjectService } from '../Services/project.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagingServiceService } from '../Services/messaging-service.service';
import swal from "sweetalert2";
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { WelcomeComponent } from '../welcome/welcome.component';
import { AuthService } from '../Services/auth.service';
import { TokenEncryptionService } from '../Services/token-encryption.service';

class User {
  id: string;
  email: string;
  ssRequest: boolean;
  scRequestStart: boolean;
  scRequestStop: boolean;
}

@Component({
    selector: 'app-verification-code',
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      MatButtonModule,
      MatIconModule,
    ],
    templateUrl: './verification-code.component.html',
    styleUrls: ['./verification-code.component.css'],
})

export class VerificationCodeComponent {
  isResend = false;
  isError = '';
  email = '';
  interValValue = 30;
  VarificationForm: UntypedFormGroup;
  authType = '';
  data;
  isDisableVarification = false;
  @ViewChild('code2Input') code2Input: ElementRef;
  @ViewChild('code3Input') code3Input: ElementRef;
  @ViewChild('code4Input') code4Input: ElementRef;
  private dbPath = "/users";

  constructor(private _sharedServices: SharedService, private ngZone: NgZone, private _projectService: ProjectService, private _snackBar: MatSnackBar, private router: Router, private route: ActivatedRoute, private messagingService: MessagingServiceService, private db: AngularFireDatabase, public dialog: MatDialog, private authService: AuthService, private tokenEncryptionService: TokenEncryptionService) {
    this._sharedServices.sideMenuSubject.next(false);
    this.route.queryParams.subscribe(params => {
      this.authType = params['type'];
      if (params['data']) {
        this.data = JSON.parse(params['data']);
      }
    });
    const email = this.tokenEncryptionService.getEncryptedItem<string>('current_email') as string;
    if (email) {
      this.email = email;
    }
    const storedDbPath = this.tokenEncryptionService.getEncryptedItem<string>('dbPath') as string;
    if (storedDbPath) {
      this.dbPath = storedDbPath;
    }
    this.VarificationForm = new UntypedFormGroup({
      code1: new UntypedFormControl("", [Validators.required, Validators.pattern(/^[0-9]$/)]),
      code2: new UntypedFormControl("", [Validators.required, Validators.pattern(/^[0-9]$/)]),
      code3: new UntypedFormControl("", [Validators.required, Validators.pattern(/^[0-9]$/)]),
      code4: new UntypedFormControl("", [Validators.required, Validators.pattern(/^[0-9]$/)]),
    });
  }
  resendCode() {

    const varificationVal = this.VarificationForm.value;
    let code = varificationVal.code1.toString() + varificationVal.code2.toString() + varificationVal.code3.toString() + varificationVal.code4.toString();
    this
      ._projectService
      .sendVarificationCode(this.email).subscribe((user: any) => {
        if (user == true || user == 'true') {
          this._snackBar.open('The recovery code sent to your email', 'Undo', {
            duration: 3000
          })
        }
      }, err => {
        this.isError = err.error.message;
        setInterval(() => {
          this.ngZone.run(() => {
            this.isError = '';
          });
        }, 3000);
        this._snackBar.open(err.error.message, 'Undo', {
          duration: 3000
        })
      })

    this.isResend = true;
    let secondsRemaining = 30;

    const intervalId = setInterval(() => {
      this.ngZone.run(() => {
        this.interValValue = secondsRemaining;
        secondsRemaining--;

        if (secondsRemaining < 0) {
          clearInterval(intervalId);
          this.isResend = false;
        }
      });
    }, 1000);
  }

  varifyAction() {
    this.isDisableVarification = true;
    const varificationVal = this.VarificationForm.value;
    let code = varificationVal.code1.toString() + varificationVal.code2.toString() + varificationVal.code3.toString() + varificationVal.code4.toString();
    if (!this.VarificationForm.valid) {
      this.isDisableVarification = false;
      return
    } else {
      this
        ._projectService
        .VarifyCode(this.email, code).subscribe((response: any) => {
          console.log(response, "verification response---")
          
          // Check if verification was successful (handle both old and new response formats)
          const isSuccess = response === true || response === 'true' || response?.success === true || response?.verified === true;
          
          if (isSuccess) {
            if (this.authType == 'signup') {
              // swal.fire({
              //   icon: 'success',
              //   title: 'Success',
              //   text: 'Your account has been verified successfully.',
              //   timer: 2000,
              //   showConfirmButton: false,
              // })
              this._snackBar.open('Your account has been verified successfully.', 'OK', {
                duration: 4000
              })
              // Clear stored email
              localStorage.removeItem('current_email');
              
              // If magic_link is provided, redirect to it for automatic login
              if (response?.magic_link) {
                // Extract the path from magic_link URL and navigate
                const url = new URL(response.magic_link);
                const loginCode = url.searchParams.get('login_code');
                if (loginCode) {
                  this.router.navigate(['/auth'], { queryParams: { login_code: loginCode } });
                } else {
                  // Fallback: redirect using full URL
                  window.location.href = response.magic_link;
                }
              } else {
                // Fallback to login page if no magic_link
                this.router.navigate(["/login"]);
              }
            }
            if (this.authType == 'login') {
              swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Your account has been verified successfully.',
                timer: 2000,
                showConfirmButton: false,
              })
              console.log('auth data---', this.data)
              this.loginAction()
            }

            if (this.authType == 'forgot') {
              const dataValue = {
                email: this.email,
                code: code
              }
              swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Your account has been verified successfully.',
                timer: 2000,
                showConfirmButton: false,
              })
              this.router.navigate(["/new-password"], { queryParams: { data: JSON.stringify(dataValue) } });
            }

            if (this.authType == 'email-verify') {
              swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Your email has been verified successfully.',
                timer: 2000,
                showConfirmButton: false,
              })
              this.router.navigate(["/user-profile-info"]);
            }
          }
          this.isDisableVarification = false;

        }, err => {
          this.isDisableVarification = false;

          if (err.error.code != 'invalid_code') {
            // setInterval(() => {
            //   this.ngZone.run(() => {
            //     this.isError = '';
            //   });
            // }, 3000); 
            console.log(err, "user---err")
            this._snackBar.open('Something went wrong', 'Undo', {
              duration: 3000
            })
          } else {
            this.isError = err.error.message;
            setInterval(() => {
              this.ngZone.run(() => {
                this.isError = '';
              });
            }, 3000);
            console.log(err, "user---err")
            this._snackBar.open(err.error.message, 'Undo', {
              duration: 3000
            })
          }
        })
    }
  }

  loginAction() {
    // console.log("====>", this.socket.);
    let check = this.data;

    // Call the centralized login handler
    this.authService.handleSuccessfulLogin(check, false, true);
  }

  create(user: User): any {
    return this.db.database.ref(this.dbPath).child(user.id).set(user);
    // return this.usersRef.push(user);
  }
  onInput(event: any, nextInput: ElementRef | null): void {
    const input = event.target;
    if (input.value.length === 1 && nextInput) {
      console.log(nextInput, nextInput.nativeElement, "next input===")
      nextInput.nativeElement.focus();
    }
  }

  openDialog(someComponent, data = {}): Observable<any> {
    const dialogRef = this.dialog.open(someComponent, {
      data,
      width: "100%",
      height: "100%",
    });
    return dialogRef.afterClosed();
  }
}
